import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    kicker: "The Problem",
    title: "A phone number is not a person.",
    body:
      "Your phonebook stores a name and a number. It doesn't remember who introduced you, what they do, what you promised, or when you last spoke. As contacts grow past a few hundred, customers, suppliers, and leads all blur into one long list.",
  },
  {
    num: "02",
    kicker: "What we settle for",
    title: "WhatsApp chats. Notebooks. Memory.",
    body:
      "Details get scattered across sticky notes, screenshots, half-remembered conversations, and a reminders app that has never met a customer. Something eventually slips — and it's almost always the follow-up that would have mattered.",
  },
  {
    num: "03",
    kicker: "What we built",
    title: "One place for every business relationship.",
    body:
      "BizBinder brings groups, contact notes, follow-up reminders, and a voice-first assistant into a single mobile app. The moment a call ends, it's ready to remember what you're not.",
  },
];

export default function Manifesto() {
  return (
    <section id="about" className="relative py-32 md:py-40" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-24">
          <div className="overline mb-4">Why BizBinder exists</div>
          <h2 className="font-display text-4xl md:text-6xl font-medium leading-[0.95] tracking-tight text-[color:var(--ink)]">
            You know more people than you can
            <span className="font-serif-italic gradient-text" style={{ fontFamily: "var(--font-serif)", fontStyle: "italic" }}>
              {" "}
              possibly remember.
            </span>
          </h2>
        </div>

        <div className="space-y-24">
          {chapters.map((c) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-120px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-black/10 pt-10 md:pt-14"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="md:col-span-3">
                <div
                  className="font-display font-medium leading-none tracking-tighter"
                  style={{
                    fontSize: "clamp(80px, 12vw, 200px)",
                    color: "transparent",
                    WebkitTextStroke: "1px rgba(10,10,31,0.35)",
                  }}
                >
                  {c.num}
                </div>
                <div className="overline mt-4">{c.kicker}</div>
              </div>
              <div className="md:col-span-9 md:pl-8">
                <h3 className="font-display text-3xl md:text-5xl font-medium leading-[1.05] tracking-tight text-[color:var(--ink)] max-w-3xl">
                  {c.title}
                </h3>
                <p className="mt-6 text-[color:var(--ink-soft)] text-base md:text-lg leading-relaxed max-w-xl">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
